import { render } from "./Col.vue?vue&type=template&id=0086ef62"
import script from "./Col.vue?vue&type=script&lang=js"
export * from "./Col.vue?vue&type=script&lang=js"
script.render = render

export default script